<template>
      <div class="artistGroups" :class="{'artist': mode === 0, 'headliner': mode === 1, 'day': mode > 1}">
          <div class="cursor-pointer byHeadliner" :class="{'active':artistGroupMode === 'byHeadliner'}" v-on:click="changeArtistGroupMode('byHeadliner')">
           HEADLINER
          </div>
         <div class="cursor-pointer byAz" :class="{'active':artistGroupMode === 'byAz'}" v-on:click="changeArtistGroupMode('byAz')">
          A-Z
          </div>
          <div class="cursor-pointer byDay" :class="{'active':artistGroupMode === 'byDay'}" v-on:click="changeArtistGroupMode('byDay')" >
          BY DAY
          </div>
        </div>
</template>
<script>
export default {
  
  name: 'app',
  props: {
    artistGroupMode: String,
    mode: Number
  },
  components: {},
  methods: {
    changeArtistGroupMode: function (newVal) {
      this.$emit('artistGroupModeSelected', newVal)
    }
  }
}

</script>
